import { Pipe, PipeTransform } from '@angular/core';
import truncate from 'truncate-html';

@Pipe({
  standalone: false,
  name: 'truncateHtml'
})
// https://www.npmjs.com/package/truncate-html
export class TruncateHtmlPipe implements PipeTransform {
  transform(html: string, length?: number, options?: any): string {
    return truncate(html, length, options);
  }
}
